<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">Buch anlegen</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-form">

            <div v-if="dataLoaded == false" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>

            <div v-else class="card-body">
              <div class="form-section-header">{{ $t('message.Book.header') }}</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.title') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('book.title')?'is-invalid':''"
                      v-model="book.title"
                      v-validate="'required'"
                      data-vv-name="book.title"
                      data-vv-model="book.title"
                      type="text"
                      placeholder="Buchtitel"
                  ></b-form-input>
                  <div v-if="errors.first('book.title')" class="text-danger">Buchtitel bitte eingeben</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.edition') }} </label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('book.edition')?'is-invalid':''"
                      v-model="book.edition"
                      type="text"
                      :placeholder="$t('message.Book.edition')"
                  ></b-form-input>
                  <div v-if="errors.first('book.edition')" class="text-danger">Buchtitel bitte eingeben</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.previousEdition') }}</label>
                </b-col>

                <b-col sm="9">
                  <multiselect
                    id="previous_edition"
                    name="previous_edition"
                    v-model="book.previous_edition"
                    :options="previousEdition"
                    :searchable="true"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :placeholder="$t('message.Book.previousEdition')"
                    :preselect-first="false"
                    track-by="id"
                    label="title">
                  </multiselect>
                  <div v-if="errors.first('book.authors')" class="text-danger">{{ $t('message.Book.errors.authors') }}</div>
                </b-col>
              </b-row>

<!--               <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.slug') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                      :class="errors.first('book.slug')?'is-invalid':''"
                      v-model="book.slug"
                      v-validate="'required'"
                      data-vv-name="book.slug"
                      data-vv-model="book.slug"
                      type="text"
                      :placeholder="$t('message.Book.slug')"
                  ></b-form-input>
                  <div v-if="errors.first('book.slug')" class="text-danger">Buchtitel bitte eingeben</div>
                </b-col>
              </b-row> -->

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.author') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <multiselect
                    id="author"
                    name="author"
                    v-model="book.authors"
                    data-vv-name="book.authors"
                    data-vv-model="book.authors"
                    :options="authorOptions"
                    :searchable="true"
                    deselect-label=""
                    select-label=""
                    selected-label=""
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Autor"
                    :preselect-first="false"
                    v-validate="'required'"
                    track-by="id"
                    label="name">
                  </multiselect>
                  <div v-if="errors.first('book.authors')" class="text-danger">{{ $t('message.Book.errors.authors') }}</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.categories') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <multiselect
                    id="author"
                    name="author"
                    v-model="book.categories"
                    data-vv-name="book.categories"
                    data-vv-model="book.categories"
                    :options="categoriesOptions"
                    :searchable="true"
                    deselect-label=""
                    select-label=""
                    selected-label=""
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :placeholder="$t('message.Book.categories')"
                    :preselect-first="false"
                    v-validate="'required'"
                    track-by="id"
                    label="name">
                  </multiselect>
                  <div v-if="errors.first('book.categories')" class="text-danger">{{ $t('message.Book.errors.categories') }}</div>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.isbn') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                    :class="errors.first('book.isbn')?'is-invalid':''"
                    v-model="book.isbn"
                    v-validate="'required'"
                    data-vv-name="book.isbn"
                    data-vv-model="book.isbn"
                    type="text"
                    :placeholder="$t('message.Book.isbn')"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.pageCount') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                    :class="errors.first('book.page_count')?'is-invalid':''"
                    v-model="book.page_count"
                    v-validate="'required|numeric'"
                    data-vv-name="book.page_count"
                    data-vv-model="book.page_count"
                    type="text"
                    :placeholder="$t('message.Book.pageCount')"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.price') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                    :class="errors.first('book.price')?'is-invalid':''"
                    v-model="book.price"
                    v-validate="'required|decimal'"
                    data-vv-name="book.price"
                    data-vv-model="book.price"
                    type="text"
                    :placeholder="$t('message.Book.price')"></b-form-input>
                </b-col>
              </b-row>


              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.publicationDate') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <datepicker
                    class="w-100"
                    :value="book.publication_date"
                    v-model="book.publication_date"
                    format="dd-MM-yyyy"
                    input-class="form-control"
                    >
                    </datepicker>
                    <input
                      type="hidden"
                      v-model="book.publication_date"
                      v-validate="'required'"
                      data-vv-name="book.publication_date"
                      data-vv-model="book.publication_date">
                    <p v-show="errors.has('book.publication_date')" class="text-danger">{{ $t("message.chooseProperDate") }}</p>

                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.type') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-select 
                    :class="errors.first('book.type')?'is-invalid':''"
                    v-model="book.type"
                    v-validate="'required'"
                    data-vv-name="book.type"
                    data-vv-model="book.type"
                    :options="types"/>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.format') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-select 
                    :class="errors.first('book.format')?'is-invalid':''"
                    v-model="book.format"
                    v-validate="'required'"
                    data-vv-name="book.format"
                    data-vv-model="book.format"
                    :placeholder="$t('message.Book.format')"
                    :options="formats"/>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.language') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-select 
                    :class="errors.first('book.language')?'is-invalid':''"
                    v-model="book.language"
                    v-validate="'required'"
                    data-vv-name="book.language"
                    data-vv-model="book.language"
                    :placeholder="$t('message.Book.language')"
                    :options="languages"/>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.publisher') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="8">
                  <b-form-select 
                    :class="errors.first('book.publisher')?'is-invalid':''"
                    v-model="publisher" 
                    :options="publisherOptions"
                    v-validate="'required'"
                    data-vv-name="book.publisher"
                    data-vv-model="book.publisher"
                    v-if="!newPublisher"
                    key="publisher" />
                  <b-form-input
                    v-else
                    :class="errors.first('book.publisher')?'is-invalid':''"
                    class="bg-warning"
                    v-model="newPublisherValue"
                    v-validate="'required'"
                    data-vv-name="newPublisherValue"
                    data-vv-model="newPublisherValue"
                    type="text"
                    :placeholder="$t('message.Book.publisher')"
                    key="newPublisher"></b-form-input>
                </b-col>

                <b-col sm="1">
                  <b-button class="i-con-h-a"
                    :class="{'bg-danger' : newPublisher, 'bg-success' : !newPublisher}"
                    @click="newPublisher = !newPublisher" title="New publisher">
                    <i v-if="!newPublisher" class="i-con i-con-plus"></i>
                    <i v-else class="i-con i-con-close"></i>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="my-1" v-if="book.shop_links && book.shop_links.length > 0">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.shopLinks') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <b-form-input
                    :class="errors.first('book.shop_links')?'is-invalid':''"
                    v-model="book.shop_links"
                    v-validate="'required'"
                    data-vv-name="book.shop_links"
                    data-vv-model="book.shop_links"
                    type="text"
                    :placeholder="$t('message.Book.shopLinks')"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.shopLinks') }} <var class="text-danger">*</var></label>
                </b-col>

                <b-col sm="9">
                  <shop-links :book="book" :shop_links="book.web_shop_links"></shop-links>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col>
                  <div class="form-section-header">Rezension</div>

                  <ckeditor
                    v-if="booksLoading == false"
                    :editor="editor" 
                    v-model="book.recension"
                    :config="editorConfig"></ckeditor>

                  <var class="text-danger">*</var> To add advert simple insert <span class="text-info">[[AD]]</span> between paragraph
                </b-col>
              </b-row>

              <div class="form-section-header">{{ $t('message.Book.sectionFileUploader') }}</div>
              <div class="dropzone mb-4">
                <div :class="{'dragActive' : $refs.upload && $refs.upload.dropActive}">
                  <label for="file" class="btn btn-primary" @click="selectFile">{{ $t('message.Book.selectFile') }}</label>
                </div>
              </div>

              <template v-if="uploadedFiles && uploadedFiles.length">
                <b-table striped hover :items="uploadedFiles" :fields="['size', 'name', 'type', 'progress', 'actions']">
                  <template slot="info" slot-scope="data">
                    <pre>
                      {{ data.item.response.data.id  }}
                    </pre>
                  </template>

                  <template slot="name" slot-scope="data">
                    <b-container fluid class="p-4">
                      <b-row>
                        <b-col>
                          {{ data.item.name }}
                        </b-col>
                      </b-row>
                      <b-row v-if="data.item.progress == 100">
                        <b-col>
                          <b-img thumbnail fluid :src="data.item.url" :alt="data.item.name" />
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>

                  <template slot="progress" slot-scope="data">
                    <img v-if="data.item.progress != 100" src="@/assets/img/loader.gif" width="32">
                    <font-awesome-icon v-else icon="check" />
                  </template>

                  <template slot="actions" slot-scope="data">
                    <a @click.prevent="deleteFile(data.index)">
                      <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                    </a>
                  </template>
                </b-table>
              </template>

              <template>
                <image-uploader
                  ref="upl"
                  :debug="0"
                  :maxWidth="350"
                  :quality="0.7"
                  outputFormat="verbose"
                  :preview=false
                  :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
                  capture="environment"
                  accept="video/*,image/*"
                  doNotResize="['gif', 'svg']"
                  @input="setImage"
                  @onUpload="startImageResize"
                  @onComplete="endImageResize"
                ></image-uploader>
              </template>

              <template v-if="book.files && book.files.length > 0">
                <b-table striped hover :items="book.files" :fields="['name', 'actions']">
                  <template slot="info" slot-scope="data">
                    <pre>
                      {{ data.item.response.data.id  }}
                    </pre>
                  </template>

                  <template slot="name" slot-scope="data">
                    <b-container fluid class="p-4">
                      <b-row>
                        <b-col>
                          {{ data.item.name }}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-img thumbnail fluid :src="data.item.url" :alt="data.item.name" />
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>

                  <template slot="progress" slot-scope="data">
                    <img v-if="data.item.progress != 100" src="@/assets/img/loader.gif" width="32">
                    <font-awesome-icon v-else icon="check" />
                  </template>

                  <template slot="actions" slot-scope="data">
                    <a @click.prevent="deleteBookFile(data.index)">
                      <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                    </a>
                  </template>
                </b-table>
              </template>


              <div class="form-buttons">
                <button type="submit" class="btn btn-danger mr-auto" @click="deleteBook">{{ $t('message.delete') }} </button>

                <button type="submit" class="btn btn-link" @click="$router.go(-1)">{{ $t('message.cancel') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import Multiselect from 'vue-multiselect';
  import {BOOK_SAVE, BOOK_UPLOAD_FILE, BOOK_UPLOAD_FILE_BASE_64, BOOKS_REQUEST_BY_ID, BOOK_GET_NEW_ID, BOOK_DELETE} from '@/store/actions/books';
  import FileUpload from 'vue-upload-component';
  import ShopLinks from '@/components/books/ShopLinks.vue';

  import firebase from 'firebase/app';

  export default {
    name: "Edit",

    components: {
      Multiselect,
      FileUpload,
      ShopLinks
    },

    data() {
      return {
        refresh: 0,

        editor: ClassicEditor,
        editorData: '',
        editorConfig: {
          // The configuration of the editor.
          toolbar: ['heading', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'undo', 'redo'],
        },

        file: null,

        edit: false,

        book: {
          id: '',
          authors: null,
          title: null,
          recension: '',
          isbn: null,
          img: null,
          slug: null,
          page_count: null,
          price: null,
          rating: null,
          publication_date: null,
          type: null,
          format: null,
          language: null,
          publisher: null,
          shop_links: null,
          files: []
        },

        uploadedFiles: [],
        newFiles: [],
        newPublisher: false,

        hasImage: false,
        image: null,

        types: [
          'Skriptum',
          'Lehrbuch',
          'Praxishandbuch',
          'Casebook / Entscheidungssammlung',
          'Aufsatzsammlung',
          'Kommentierte Gesetzesausgabe',
          'Kommentar',
          'Dissertation / Aufsatz',
          'Mustersammlung',
          'Unkommentierte Gesetzesausgabe',
        ],

        formats: [
          'Heft',
          'Softcover',
          'Hardcover',
          'Online',
          'Datenträger',
          'Loseblattsammlung',
        ],

        languages: [
          'Deutsch',
          'Englisch',
        ],
      }
    },

    methods: {
      async upload(e) {
        this.uploadedFiles.forEach(elem => {
          let file = this.$refs.upload.get(elem.id).file

          this.$store.dispatch(BOOK_UPLOAD_FILE, {bookId: this.book.id, file:file}).then(file => {
            elem.url = file.url
            elem.progress = 100
            this.newFiles.push(file)
          })
        })
      },

      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Book.errors.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.edit) {
              return this.updateBook();
            }

            return this.saveBook();
          }
        });
      },

      async deleteBook() {
        this.$swal({
          text: this.$t("message.deleteQuestion"),
          type: 'warning',
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("message.confirmDelete"),
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch(BOOK_DELETE, this.book)
              .then((response) => {
                this.$swal.fire(
                  this.$t("message.deleted"),
                  this.$t("message.deletedInfo"),
                  'success'
                ).then(() => {
                  this.$router.push({name: 'BookList'});
                })
              })
          }
        })
      },

      async saveBook() {
        this.book.files = this.newFiles

        this.$store.dispatch(BOOK_SAVE, this.book)
          .then(() => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullySaved"),
              type: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$router.push({name: 'BookList'});
            })
          })
          .catch(err => {
            alert('error')
            console.log(err)
          })
      },

      async updateBook() {
        this.book.files = this.book.files.concat(this.newFiles)

        this.$store.dispatch(BOOK_SAVE, this.book)
          .then(() => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullyUpdated"),
              type: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$router.push({name: 'BookList'});
            })
          }).catch(err => {
            alert('error')
            console.log(err)
          })
      },

      getBook(id) {
        if (id != undefined) {
          this.$store.dispatch(BOOKS_REQUEST_BY_ID, id)
            .then(book => {
              this.book = JSON.parse(JSON.stringify(book))
            }).catch(err => {
              console.log(err)
            })
        }
      },

      deleteFile(index) {
        let elemToDelete = this.uploadedFiles.splice(index, 1);
        
        let deleteIndex = this.book.files.findIndex(elem => elem.name = elemToDelete[0].name)

        if (deleteIndex != -1) {
          this.newFiles.splice(deleteIndex, 1);
        }
        
      },

      deleteBookFile(index) {
        this.book.files.splice(index, 1);
      },

      setImage: function (file) {
        this.hasImage = true
        this.image = file
      },

      startImageResize() {
        console.log('startImageResize');
      },

      endImageResize() {
        this.$store.dispatch(BOOK_UPLOAD_FILE_BASE_64, {bookId: this.book.id, file: this.image}).then(file => {
          this.newFiles.push(file)

          file.progress = 100

          this.uploadedFiles.push(file)
        })
      },

      selectFile() {
        this.$refs.upl.$el.lastChild.click();
      },
    },

    computed: {
      dataLoaded() {
        return this.booksLoaded && this.publishersLoaded && this.authorsLoaded
      },

      rerender() {
        return this.refresh
      },

      previousEdition() {
        return this.books.map(el => { return {id: el.id, title: el.title} });
      },

      categoriesOptions() {
        return this.categories.map(el => { return {id: el.id, name: el.name} });
      },

      authorOptions() {
        return this.authors.map(el => { return {id: el.id, name: el.name} });
      },

      publisher: {
        get: function() {
          return (this.book.publisher && this.book.publisher.id != null) ? this.book.publisher.id : null
        },
        set: function(value) {
          let p = this.publishers.find(elem => elem.id == value)
          this.book.publisher = p
        },
      },

      newPublisherValue: {
        get: function() {
          return (this.book.publisher && this.book.publisher.id == undefined) ? this.book.publisher.name : null
        },
        set: function(value) {
          this.book.publisher = {name: value}
        },
      },

      publisherOptions() {
        return this.publishers ? this.publishers.map(el => { return {value: el.id, text: el.name} }): [];
      }
    },

    mounted() {
      if (this.$route.params.id == undefined) {
        this.$store.dispatch(BOOK_GET_NEW_ID).then(newBookId => {
          this.book.id = newBookId
        })
      } else {
        this.getBook(this.$route.params.id)
        this.edit = true 
      }
    },

    watch: {}
  }
</script>

<style>
.dragActive{
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4{
    input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5{
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}

.img-thumbnail {
  max-width: 300px;
}

.fileinput {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>